import * as React from 'react'
import { Button } from 'react-bootstrap'
import { useLocation } from 'react-router-dom'
import Footer from 'components/Footer'
import Header from 'components/Header'
import loginData from 'utilities/loginData'

type StateValue = {
  email: string
}

/**
 * お問い合わせ受付完了
 * @returns
 */
const SceneComponent: React.FC = () => {
  const location = useLocation()
  const stateValue = (location.state as StateValue) ?? {
    email: 'mail@example.com',
  }
  const nextLink = loginData.isLoggedIn()
    ? {
        path: '/myPage',
        text: 'マイページへ戻る',
      }
    : {
        path: '/login',
        text: 'ログイン画面へ戻る',
      }
  return (
    <>
      <Header title="お問い合わせ受付完了" />
      <main>
        <section className="mx-4 my-5">
          <div>
            <p>{stateValue.email}</p>
            <p className="fw-bold">メールが送信されました</p>
          </div>
          <div className="mt-5">
            <p>ご登録のメールアドレスにお問い合わせ受付完了の案内メールを送信しましたのでご確認ください。</p>
            <p>案内メールが届かない場合、迷惑メールフォルダに振り分けられている可能性があります。</p>
          </div>
          <div className="mt-4">
            <Button variant="primary" className="w-100 py-4" href={nextLink.path}>
              {nextLink.text}
            </Button>
          </div>
        </section>
      </main>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
